import _ from 'lodash';

import { default as _Account } from './account';
import { default as _AccountTemplate } from './account-template';
import { default as _AppCard } from './app-card';
import { default as _Blacklist } from './blacklist';
import { default as _Channel } from './channel';
import { default as _Collection } from './collection';
import { default as _DisplayContainer } from './display-container';
import { default as _DisplayUnit } from './display-unit';
import { default as _Domain } from './domain';
import { default as _EmailIntegrations } from './email-integrations';
import { default as _Entitlement } from './entitlement';
import { default as _Experience } from './experience';
import { default as _ExperienceInsights } from './experience-insights';
import { default as _ExportTask } from './export-task';
import { default as _Form } from './form';
import { default as _Integration } from './integration';
import { default as _Navigator } from './navigator';
import { default as _Page } from './page';
import { default as _PageTemplate } from './page-template';
import { default as _PinnedContainer } from './pinned-container';
import { default as _PublishingDestinations } from './publishing-destinations';
import { default as _SmartUrl } from './smart-url';
import { default as _Theme } from './theme';
import { default as _User } from './user';
import { default as _Winner } from './winner';
import { default as _Workspace } from './workspace';
import { default as _Promotion } from './promotion';

const Entities = [
  _Account,
  _AccountTemplate,
  _AppCard,
  _Blacklist,
  _Channel,
  _Collection,
  _DisplayContainer,
  _DisplayUnit,
  _Domain,
  _EmailIntegrations,
  _Entitlement,
  _Experience,
  _ExperienceInsights,
  _ExportTask,
  _Form,
  _Integration,
  _Navigator,
  _Page,
  _PageTemplate,
  _PinnedContainer,
  _PublishingDestinations,
  _SmartUrl,
  _Theme,
  _User,
  _Winner,
  _Workspace,
  _Promotion,
];

// Not all entities define reducers, so filter out the ones that don't
const reducers = _.reduce(
  _.filter(Entities, (Entity) => _.has(Entity, 'reducer')),
  (acc, Entity) => {
    acc[Entity.namespace] = Entity.reducer;
    return acc;
  },
  {}
);

// Not all entities define sagas, so filter out the ones that don't
const sagas = _.flatMap(
  _.filter(Entities, (Entity) => _.has(Entity, 'sagas')),
  (Entity) => Entity.sagas
);

const namespace = 'entities';

export default { sagas, reducers, namespace };

const _exportKeys = ['Actions', 'Api', 'Collection', 'Enums', 'Model', 'name', 'pluralName', 'Selectors', 'Utils'];
// Only export the keys that are used
export const Account = _.pick(_Account, _exportKeys);
export const AccountTemplate = _.pick(_AccountTemplate, _exportKeys);
export const AppCard = _.pick(_AppCard, _exportKeys);
export const Blacklist = _.pick(_Blacklist, _exportKeys);
export const Channel = _.pick(_Channel, _exportKeys);
export const Collection = _.pick(_Collection, _exportKeys);
export const DisplayContainer = _.pick(_DisplayContainer, _exportKeys);
export const DisplayUnit = _.pick(_DisplayUnit, _exportKeys);
export const Domain = _.pick(_Domain, _exportKeys);
export const EmailIntegrations = _.pick(_EmailIntegrations, _exportKeys);
export const Entitlement = _.pick(_Entitlement, _exportKeys);
export const Experience = _.pick(_Experience, _exportKeys);
export const ExperienceInsights = _.pick(_ExperienceInsights, _exportKeys);
export const ExportTask = _.pick(_ExportTask, _exportKeys);
export const Form = _.pick(_Form, _exportKeys);
export const Integration = _.pick(_Integration, _exportKeys);
export const Navigator = _.pick(_Navigator, _exportKeys);
export const Page = _.pick(_Page, _exportKeys);
export const PageTemplate = _.pick(_PageTemplate, _exportKeys);
export const PinnedContainer = _.pick(_PinnedContainer, _exportKeys);
export const PublishingDestinations = _.pick(_PublishingDestinations, _exportKeys);
export const SmartUrl = _.pick(_SmartUrl, _exportKeys);
export const Theme = _.pick(_Theme, _exportKeys);
export const User = _.pick(_User, _exportKeys);
export const Winner = _.pick(_Winner, _exportKeys);
export const Workspace = _.pick(_Workspace, _exportKeys);
export const Promotion = _.pick(_Promotion, _exportKeys);
